import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SalesforceUniqueFieldTarget } from '@r1-compass-library/models/division/division-mapping.model';
import { TemplateCriteria } from './template-criteria.model';
import { GroupingLogicForm } from '@r1-compass-library/components';
import {
    GenericSelectionCriterionForm,
    SalesHistorySelectionCriterionDataForm,
    SelectionCriterionForm,
    WebActivitySelectionCriterionDataForm,
    WebSearchSelectionCriterionDataForm,
} from '../criteria/selection-criteria-form.model';
import { SelectionCriterion } from '../criteria/selection-criteria.model';
import { GroupingLogic } from '../public-api';

export type TemplateCriteriaDefinitionModel = {
    name: string;
    description: string;
    salesforceTarget?: SalesforceUniqueFieldTarget;
};

export type TemplateCriteriaBuilderModel = {
    groupingLogic: GroupingLogic;
    selectionCriteria: SelectionCriterion[];
};

export class TemplateCriteriaDefinitionForm {
    name = new FormControl<string>('', { validators: Validators.required, nonNullable: true });
    description = new FormControl<string>('', { nonNullable: true });
    salesforceTargetId = new FormControl<string | undefined>(undefined, {
        validators: Validators.required,
        nonNullable: true,
    });

    constructor(template?: TemplateCriteria) {
        this.name.setValue(template?.name ?? '');
        this.description.setValue(template?.description ?? '');
        this.salesforceTargetId.setValue(template?.config.salesforceTarget?.id);
    }
}

export class TemplateCriteriaBuilderForm {
    groupingLogic = new FormGroup<GroupingLogicForm>(new GroupingLogicForm());
    selectionCriteria = new FormArray<FormGroup<SelectionCriterionForm>>([], { validators: Validators.required });

    constructor(template?: TemplateCriteria) {
        if (template) {
            this.groupingLogic.patchValue(
                new FormGroup(new GroupingLogicForm(template.config.groupingLogic)).getRawValue()
            );
            template.config.selectionCriteria?.forEach(criterion => {
                this.selectionCriteria.push(new FormGroup(new SelectionCriterionForm(criterion.type, criterion)));
            });
        }
    }
}

//Type narrowers

export type argTypeForm =
    | FormGroup<GenericSelectionCriterionForm>
    | FormGroup<WebSearchSelectionCriterionDataForm>
    | FormGroup<WebActivitySelectionCriterionDataForm>
    | FormGroup<SalesHistorySelectionCriterionDataForm>
    | FormGroup<undefined>;
export function isGenericForm(arg: argTypeForm): arg is FormGroup<GenericSelectionCriterionForm> {
    const ctrlType = (arg as FormGroup<GenericSelectionCriterionForm>).controls.type.value;
    return ctrlType === 'generic' || ctrlType === 'model';
}
export function isWebSearchForm(arg: argTypeForm): arg is FormGroup<WebSearchSelectionCriterionDataForm> {
    return (arg as FormGroup<WebSearchSelectionCriterionDataForm>).controls.type.value === 'web search';
}
export function isWebActivityForm(arg: argTypeForm): arg is FormGroup<WebActivitySelectionCriterionDataForm> {
    return (arg as FormGroup<WebActivitySelectionCriterionDataForm>).controls.type.value === 'web activity';
}
export function isSalesHistoryForm(arg: argTypeForm): arg is FormGroup<SalesHistorySelectionCriterionDataForm> {
    return (arg as FormGroup<SalesHistorySelectionCriterionDataForm>).controls.type.value === 'sales history';
}
